import { delay } from 'redux-saga';
import { call, put, all } from 'redux-saga/effects';

import { transformRfq } from 'Utils/transform';
import { downloadUrl, isEmami } from 'Utils';
import { getItemFromLocal } from 'Utils/localStorage';

import { 
    getDataWithToken, 
    postDataWithToken,
    putDataWithToken,
    uploadFile,
    uploadFileWithSyncCalls,
    deleteDataWithToken,
    getLPPDataWithoutToken,
    getDataWithoutToken,
    getDataSSPWithToken,
    getLCLDataWithToken,
    putLCLDataWithToken,

    postDataWithoutToken,

    postLPPDataWithoutToken,
    putDataWithTokenToIndents,
    adminBaseUrl,
    getAdminDataWithToken,

    CHALLENGE_PRICE_URL,
    CP_FORM_MEGA_SAVE_URL,
    SEEKER_TRANSPORTERS_LIST_URL,
    SEEKER_TRANSPORTER_BIDS_URL,
    SEND_LOI_URL,
    COUNTER_PRICE_URL,
    COUNTER_SEEKER_URL,
    ACCEPT_REJECT_LOI_URL,
    ACCEPT_REJECT_CP_URL,
    CHANGE_BID_END_URL,
    CHANGE_TRIP_BID_END_URL,
    BID_EXTENSION_APPROVAL_URL,

    DOWNLOAD_BIDDING_DETAILS_URL,
    UPLOAD_BIDDING_DETAILS_URL,
    DOWNLOAD_BIDDING_DETAILS_TRANSPORTER_URL,
    UPLOAD_BIDDING_DETAILS_TRANSPORTER_URL,
    CHALLENGE_PRICE_FORM_URL,
    LPP_GET_API_URL,
    CP_LPP_URL,
    EDIT_CONTRACT_TO_DATE_URL, 
    ADD_LOI_APPROVER_URL,
    SEND_APPROVER_LOI_MESSAGE_URL,
    EDIT_TK11_CONTRACT_DATA_URL,
    DELETE_TRIP_DETAILS_URL,
    CHANGE_TRIP_BASE_VOLUME_URL,
    POST_OTHER_COST_CP_URL,
    OTHER_COST_ACCEPT_REJECT_CP_URL,
    DOWNLOAD_BIDDING_SEEKER_TRAIL_URL,
    DOWNLOAD_BIDDING_PROVIDER_TRAIL_URL,
    DOWNLOAD_COURIER_BIDDING_PROVIDER_URL,
    UPLOAD_COURIER_BIDDING_PROVIDER_URL,
	PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE_URL,
    PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE_URL,
    DOWNLOAD_COURIER_TRIPS_TEMPLATE_URL,
    UPLOAD_COURIER_TRIPS_URL,
    FILE_UPLOAD_POST_API_URL,
    CLEAR_MESSAGE_URL,
    DOWNLOAD_MULTI_MODE_BID_DETAILS_TRANSPORTER_URL,
    UPLOAD_MULTI_MODE_BID_TRANSPORTER_URL,
    SYSTEM_SUGGESTED_PRICE_URL,
    CHECK_CONTRACT_EXIST_URL,
    FREIGHT_CALCULATATION_URL,
    GET_OTHERS_LPP_URL,
    AMMENDMENT_LIST_URL,
    AMMENDMENT_APPROVE_URL,
    DOWNLOAD_BID_RATE_TEMPLATE_URL,
    UPLOAD_BID_RATE_URL,
    DOWNLOAD_TRUCKS_DETAILS_TEMPLATE_URL,
    UPLOAD_TRUCKS_DETAILS_URL,
    NUMBER_OF_VEHICLE_PLACED_URL,
    EXISITING_CONTRACT_DETAILS_URL,
    GENERATE_CONTRACT_URL,
    DOWNLOAD_MULTIMODE_EXISITING_CONTRACT_URL,
    UPLOAD_MULTIMODE_EXISITING_CONTRACT_URL,
    GENERATED_CONTRACTS_LIST_URL,
    CLOSED_RFQ_URL,
    ACCEPTANCE_OF_CEILING_PRICE_URL,
    CANCELLED_LOI_URL,
    DOWNLOAD_AWL_MULTIMODE_TEMPLATE_URL,
    UPLOAD_AWL_MULTIMODE_EXCEL_URL,
    AIR_SHIPMENT_TRACKING_URL,
    CONTAINER_SHIPMENT_TRACKING_URL,
    REVOKE_WITHDRAW_BID_URL,
    BL_SHIPMENT_TRACKING_URL,
    GET_ROUTE_MASTER_URL,
    ADD_ROUTE_MASTER_URL,
    UPDATE_ROUTE_MASTER_URL,
    DELETE_ROUTE_MASTER_URL,
    UPLOAD_ROUTE_MASTER_DETAILS_URL,
    DOWNLOAD_ROUTE_MASTER_DETAILS_URL,
    DOWNLOAD_ROUTE_MASTER_TEMPLATE_URL,
    CHECK_FTL_CONTRACT_EXIST_URL,
    SHARE_OF_BUSINESS_URL,
    UPDATE_DPH_URL,
    EXTEND_TRIP_LEVEL_CONTRACT_TENURE_URL,
    TRIP_LEVEL_BID_TIME_EXTENSION_URL,
    REJECT_LOI_FROM_APPROVER_URL,
    DOWNLOAD_EXIST_CONTRACT_TEMPLATE_URL,
    UPLOAD_EXIST_CONTRACT_URL,
    UPLOAD_FILE_IN_CONTRACT_RECORDS_RFQ_URL,
    CREATE_INDENTS_URL,
    DELETE_UPLOADED_FILE_URL,
    POST_DPH_APPROVER_URL,
    POST_DPH_APPROVAL_URL,
    RETRIGGER_TK11_FOR_RFQ_URL,
    GET_EVENT_DETAILS_URL,
    DELETE_EVENT_DETAIL_URL,
    DOWNLOAD_EVENT_DETAIL_TEMPLATE_URL,
    UPLOAD_RFQS_FOR_EVENT_URL,
    SCHEDULE_EVENT_URL,
    GET_EVENT_STATUS_URL,
    GET_EVENT_RFQ_DETAILS_URL,
    UPDATE_EVENT_RFQ_URL,
    UPDATE_EVENT_RFQ_TRIPS_URL,
    POST_SOB_TEMPLATE_URL,
    GET_SOB_TEMPLATE_URL,
    GET_WINNING_TRANSPORTERS_URL,
    DELETE_WINNING_TRANSPORTER_URL,
    GET_OFFLINE_SLABWISE_TRIPS_TEMPLATE_URL,
    POST_UPLOAD_OFFLINE_SLABWISE_TRIPS_URL,
    GET_ALL_MASTER_CONTRACTS_URL,
    GET_FROM_ROUTE_LIST_URL,
    GET_BRANCH_YARD_URL,
    POST_SEARCH_ROUTE_MASTER_URL,
    GET_GENERATE_ROUTE_CODES_URL,
    ADD_ADDITIONAL_TRANSPORTERS_DURING_BIDDING_URL,
    GET_RFQ_LEVEL_REVISED_PRICE_DETAILS_URL,
    GET_TRANSPORTER_REVISED_PRICE_DETAILS_URL,
    DOWNLOAD_REVISED_PRICE_DETAILS_URL,
    GET_TRANSPORTER_WISE_REVISED_PRICE_URL,
    GENERATE_PLAN_IN_MASTER_CONTRACT_URL,
    GET_CONTRACT_DETAILS,
    GET_CHILD_CONTRACT_TK11,
    GET_MASTER_CONTRACT_TK11,
    UPLOAD_OTHER_CHARGES_URL,
    GET_OTHER_CHARGES_TEMPLATE_URL,
    UPDATE_POST_BID_TO_PRE_BID_RFQ_URL,
    DOWNLOAD_TRANSPORTER_WISE_BID_DETAILS_URL,
    GET_CONTRACT_DETAILS_URL,
    GET_CHILD_CONTRACT_TK11_URL,
    GET_MASTER_CONTRACT_TK11_URL,
    RETRIGGER_MASTER_CONTRACT_TK11_URL,
    SAVE_RETRIGGER_MC_TK11_URL,
    GET_LOCATION_DROPDOWN_VALUES_URL,
    GET_SECONDARY_CONTRACTS_URL,
    DOWNLOAD_SECONDARY_CONTRACTS_TEMPLATE_URL,
    UPLOAD_SECONDARY_CONTRACTS_TRIPS_URL,
    POST_SECONDARY_CONTRACTS_URL,
    DELETE_SECONDARY_CONTRACT_RFQ_URL,
    GET_SECONDARY_CONTRACT_BY_RFQID_URL,
    UPDATE_SECONDARY_CONTRACTS_URL,
    MULTI_CONTRACT_SEND_LOI_FOR_APPROVAL_URL,
    GET_MULTI_CONTRACT_DATA_URL,
    DELETE_MULTI_CONTRACT_URL,
    UPDATE_MULTI_CONTRACT_URL,
    DOWNLOAD_TEMPLATE_MULTI_CONTRACT_URL,
    UPLOAD_MULTI_CONTRACT_URL,
    GET_OFFLINE_CONTRACTS_DETAILS_TO_UPDATE_URL,
    POST_OFFLINE_CONTRACTS_DETAILS_UPDATED_DETAILS_URL,
    POST_ACCEPT_CEILING_PRICE_LOI_URL,
    POST_TRIP_FILE_REMARKS_URL,
    POST_OVERALL_ALLOCATION_URL,
    // POST_COST_HEAD_CP_ACCEPT_REJECT_URL,
    // POST_COST_HEAD_COUNTER_PRICE_URL,
    // POST_COST_HEAD_COUNTER_ACCEPT_REJECT_URL,
    DELETE_SECONDARY_CONTRACT_RFQ_TRIP_URL,
    EXTEND_BID_TIME_FOR_SINGLE_BIDDED_TRIPS_URL,
    SECONDARY_CONTRACT_TENURE_VALIDATION_URL,
    REACTIVATE_TK11_URL,
    CANCEL_CP_URL,
    ACCEPT_TERMS_AND_CONDITIONS_URL,
    GET_PROCUREMENT_LPP_URL,
    GET_PR_TRACKING_URL,
    GET_TRIPS_LOGS_URL,
    DELETE_CONTRACT_RECORD_URL,
    GENERATE_SERVICE_PO_URL,
    DOWNLOAD_MULTIMODAL_OFFLINE_CONTRACT_URL,
    UPLOAD__MULTIMODAL_OFFLINE_CONTRACT_URL,
    GET_SIDEBAR_CONFIG_URL,
    GET_DAAI_INTEGRATION_CONFIG_URL,
    FETCH_COMPANY_DATA_URL,
    getIndentingDataWithToken,
} from 'Utils/api';

import {
    CHALLENGE_PRICE_SUCCESS,
    CHALLENGE_PRICE_SUBMITTING,

    GET_SEEKER_TRANSPORTERS_LOADING,
    GET_SEEKER_TRANSPORTERS_SUCCESS,

    GET_SEEKER_TRANSPORTER_BIDS_LOADING,
    GET_SEEKER_TRANSPORTER_BIDS_SUCCESS,

    TOAST_ERROR,
    TOAST_SUCCESS,

    SEND_LOI_SUBMITTING,
    SEND_LOI_SUCCESS,

    COUNTER_PRICE_SUBMITTING,
    COUNTER_PRICE_SUCCESS,

    ACCEPT_REJECT_LOI_SUBMITTING,
    ACCEPT_REJECT_LOI_SUCCESS,

    DOWNLOAD_BIDDING_DETAILS_SUCCESS,
    DOWNLOAD_BIDDING_DETAILS_SUBMITTING,
    UPLOAD_BIDDING_DETAILS_SUCCESS,
    UPLOAD_BIDDING_DETAILS_SUBMITTING,

    POST_CHALLENGE_PRICE_FORM_SUBMITTING,
    POST_CHALLENGE_PRICE_FORM_SUCCESS,

    LPP_DATA,
    UPDATE_LPP_DATA,
    SAVE_EXTEND_DATE_SUBMITTING,
    SAVE_EXTEND__DATE_SUCCESS,
    DELETE_TRIP_DETAILS,
    DELETE_TRIP_DETAILS_SUCCESS,
    ADD_LOI_SUCCESS,
    ADD_LOI_SUBMITTING,
    DOWNLOAD_BIDDING_TRAIL_SUCCESS,
    DOWNLOAD_BIDDING_TRAIL_SUBMITTING,
    CLEAR_MESSAGE_SUCCESS,
    GET_AMMENDMENT_STARTED,
    SAVE_AMMENDMENT_DATA_LIST,
    PUT_AMMENDMENT_APPROVE_STARTED,
    SAVE_AMMENDMENT_APPROVE_LIST,
    DOWNLOAD_BIDDING_RATE_SUBMITTING,
    DOWNLOAD_BIDDING_RATE_SUCCESS,
    UPLOAD_BIDDING_RATE_SUBMITTING,
    UPLOAD_BIDDING_RATE_SUCCESS,
    DOWNLOAD_TRUCKS_SUBMITTING,
    DOWNLOAD_TRUCKS_SUCCESS,
    UPLOAD_NUMBER_OF_TRUCKS_SUBMITTING,
    UPLOAD_NUMBER_OF_TRUCKS_SUCCESS,
    NUMBER_OF_VEHICLE_PLACED_SUBMITTING,
    NUMBER_OF_VEHICLE_PLACED_SUCCESS,
    GET_EXISTING_CONTRACT_DETAILS_SUBMITTING,
    GET_EXISTING_CONTRACT_DETAILS_SUCCESS,
    GET_GENERATED_CONTRACT_DETAILS_SUCCESS,
    END_LOADER,
    START_LOADER,
    REVOKE_WITHDRAW_BID_SUCCESS,
    REVOKE_WITHDRAW_BID_SUBMITTING,
    LOI_CANCELLED_SUBMITTING,
    LOI_CANCELLED_UPDATED_SUCCESS,
    SAVE_CARGO_SHIPMENT_TRACKING_DATA,
    SAVE_EVENT_DETAILS,
    SAVE_EVENT_STATUS,
    GET_RFQ_DETAIL_SUCCESS,
    SAVE_WINNING_TRANSPORTERS,
    GET_ALL_MASTER_CONTRACTS_LOADING,
    GET_ALL_MASTER_CONTRACTS_SUCCESS,
    GET_FROM_ROUTE_SUCCESS,
    GET_FROM_ROUTE_LOADING,
    GET_BRANCH_YARD_FILTERS_LOADING,
    GET_BRANCH_YARD_FILTERS_SUCCESS,
    POST_SEARCH_ROUTES_CONTRACTS_SUCCESS,
    POST_SEARCH_ROUTES_CONTRACTS_LOADING,
    GET_CONTRACT_DETAILS_LOADING,
    GET_CONTRACT_DETAILS_SUCCESS,
    GET_CONTRACT_CHILD_DETAILS_LOADING,
    GET_CONTRACT_CHILD_DETAILS_SUCCESS,
    RETRIGGER_MASTER_CONTRACTS_TK11_LOADING,
    RETRIGGER_MASTER_CONTRACTS_TK11_SUCCESS,
    SAVE_SECONDARY_CONTRACTS_LIST,
    GET_MULTI_CONTRACT_SUCCESS,
    GET_MULTI_CONTRACT_LOADING,
    SAVE_PR_TRACKING_DETAILS,
    ACCEPT_TERMS_AND_CONDITIONS
} from 'Constants/actionConstants';

import Transporter from 'Models/Transporter';
import Trip from 'Models/Trip';
import RFQ from 'Models/RFQ';
import { TRANSPORTER } from 'Constants/commonConstants';
import { getPresignedUrl } from './common';

export function* postChallengePrice(action) {
    try{
        yield put({
            type: CHALLENGE_PRICE_SUBMITTING
        });
        const data = yield call(putDataWithToken, CHALLENGE_PRICE_URL,  action.data);
        yield put({
            type: CHALLENGE_PRICE_SUCCESS,
        });
        yield put({
            type: (data || {}).status === 200 ? TOAST_SUCCESS : TOAST_ERROR,
            message: (data || {}).message || "Challenge Price Submitted Successfully"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: CHALLENGE_PRICE_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}
export function* postCPformMegaSave(action) {
    try{
        yield put({
            type: CHALLENGE_PRICE_SUBMITTING
        });
        const data = yield call(putDataWithToken, CP_FORM_MEGA_SAVE_URL,  action.data);
        yield put({
            type: CHALLENGE_PRICE_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message?data.message:"Oops! Something Went Wrong"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: CHALLENGE_PRICE_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}
export function* sendLOI(action) {
    try{
        yield put({
            type: SEND_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, SEND_LOI_URL,  action.data);
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: "LOI Sent Successfully"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}
export function* getTransporters(action) {
    try{
        yield put({
            type: GET_SEEKER_TRANSPORTERS_LOADING
        });
        const data = yield call(getDataWithToken, SEEKER_TRANSPORTERS_LIST_URL,  action.params);
        const rfq = transformRfq(data.data.rfq);
        const transporters = data.data.list.map((transporter)=> {
            return new Transporter(transporter);
        });
        yield put({
            type: GET_SEEKER_TRANSPORTERS_SUCCESS,
            transporters,
            rfq
        });
        if(action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch(e) {
        yield put({
            type: GET_SEEKER_TRANSPORTERS_SUCCESS,
            transporters: [],
            rfq: new RFQ()
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}
export function* getTransporterBids(action) {
    try{
        yield put({
            type: GET_SEEKER_TRANSPORTER_BIDS_LOADING
        });
        const data = yield call(getDataWithToken, SEEKER_TRANSPORTER_BIDS_URL,  action.params);
        const trips = data.data.list.map((trip)=> {
            return new Trip(trip);
        });
        const transporter = new Transporter(data.data.transporter_details);
        yield put({
            type: GET_SEEKER_TRANSPORTER_BIDS_SUCCESS,
            trips,
            transporter,
            otherCharges: data && data.data && data.data.other_charges_list || []
        });
        if(action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}


export function* postCounter(action) {
    try{
        yield put({
            type: COUNTER_PRICE_SUBMITTING
        });
        const data = yield call(putDataWithToken, COUNTER_PRICE_URL,  action.params);
        yield put({
            type: COUNTER_PRICE_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: (data || {}).message || "Counter Price Submitted Successfully"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: COUNTER_PRICE_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* postCounterForSeeker(action) {
    try{
        yield put({
            type: COUNTER_PRICE_SUBMITTING
        });
        const data = yield call(putDataWithToken, COUNTER_SEEKER_URL,  action.params);
        yield put({
            type: COUNTER_PRICE_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message ? data.message : "Counter Price Updated Successfully"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: COUNTER_PRICE_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* acceptRejectLoi(action) {
    try{
        yield put({
            type: ACCEPT_REJECT_LOI_SUBMITTING
        });
        const data = yield call(putDataWithTokenToIndents, ACCEPT_REJECT_LOI_URL,  action.data);
        yield put({
            type: ACCEPT_REJECT_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Updated The Status"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: COUNTER_PRICE_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}
export function* acceptRejectCP(action) {
    try{
        yield put({
            type: ACCEPT_REJECT_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, ACCEPT_REJECT_CP_URL,  action.data);
        yield put({
            type: ACCEPT_REJECT_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Updated The Status"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        // yield put({
        //     type: COUNTER_PRICE_SUCCESS,
        // });
        // reset acceptRejectLoi.dataSubmitting, or the screen loader never stops
        yield put({
            type: ACCEPT_REJECT_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}
export function* changeBidEnd(action) {
    try{
        const data = yield call(putDataWithToken, CHANGE_BID_END_URL,  action.data);
        yield put({
            type: ACCEPT_REJECT_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Updated Bid End Time"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}
export function* postBidExtensionApproval(action) {
    try{
        const data = yield call(putDataWithToken, BID_EXTENSION_APPROVAL_URL,  action.data);
        yield put({
            type: TOAST_SUCCESS,
            message: action.data.bid_extension_approve ? "Successfully Approved Bid Extension Request" : "Successfully Sent Bid Extension Request"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}
export function* changeTripBidEnd(action) {
    try{
        const data = yield call(putDataWithToken, CHANGE_TRIP_BID_END_URL,  action.data);
        // yield put({
        //     type: ACCEPT_REJECT_LOI_SUCCESS,
        // });
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Updated Bid End Time"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* getDownloadBiddingDetails(action) {
    try{
        let data;
        yield put({
            type: DOWNLOAD_BIDDING_DETAILS_SUBMITTING
        });
        if(action.whoami === TRANSPORTER) {
            let url = (action.params.serviceType === 2) ? DOWNLOAD_COURIER_BIDDING_PROVIDER_URL : (action.params.serviceType === 4)? DOWNLOAD_MULTI_MODE_BID_DETAILS_TRANSPORTER_URL: DOWNLOAD_BIDDING_DETAILS_TRANSPORTER_URL;
            data = yield call(getDataWithToken, url, action.params);
        } else {
            let url =(action.params.serviceType === 3) ? DOWNLOAD_COURIER_TRIPS_TEMPLATE_URL : DOWNLOAD_BIDDING_DETAILS_URL;
            data = yield call(getDataWithToken, url, action.params);
        }
        
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        yield put({
            type: DOWNLOAD_BIDDING_DETAILS_SUCCESS,
            url: presignedUrlData.url
        });
        if(action.onSuccess) {
            action.onSuccess(presignedUrlData);
        }
    } catch(e) {
        yield put({
            type: DOWNLOAD_BIDDING_DETAILS_SUCCESS,
            url: '/'
        });
        
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}
export function* uploadBiddingDetails(action) {
    try{
        let data
        yield put({
            type: UPLOAD_BIDDING_DETAILS_SUBMITTING
        });
        if(action.whoami === TRANSPORTER) {
            let url = (action.params.serviceType === 2) ? UPLOAD_COURIER_BIDDING_PROVIDER_URL :(action.params.serviceType === 4)?UPLOAD_MULTI_MODE_BID_TRANSPORTER_URL: UPLOAD_BIDDING_DETAILS_TRANSPORTER_URL;
            data = yield call(uploadFile, url, action.file, action.params);
        } else {
            // data = yield call(uploadFileWithSyncCalls, UPLOAD_BIDDING_DETAILS_URL, action.file, action.params);
            let url = (action.params && action.params.serviceType === 3 ) ? UPLOAD_COURIER_TRIPS_URL : FILE_UPLOAD_POST_API_URL;
            data = yield call(uploadFileWithSyncCalls, url, action.file, action.params);
        }
        yield put({
            type: UPLOAD_BIDDING_DETAILS_SUCCESS
        });
        
        yield put({
            type: (data.status === 400) ? TOAST_ERROR : TOAST_SUCCESS,
            duration: 6,
            message: data && data.message ? data.message : "Bidding Details Uploaded Successfully"
        });
        if(action.onSuccess) {
            console.log('ON SUCCESS BIDDING DETASILS');
            action.onSuccess(data.data);
        }
    } catch(e) {
        if(action.onError) {
            action.onError();
        }
        yield put({
            type: UPLOAD_BIDDING_DETAILS_SUCCESS
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}
export function* postChallengePriceForm(action) {
    try{
        yield put({
            type: POST_CHALLENGE_PRICE_FORM_SUBMITTING
        });
        const data = yield call(putDataWithToken, CHALLENGE_PRICE_FORM_URL, action.data);
        yield put({
            type: POST_CHALLENGE_PRICE_FORM_SUCCESS
        });
        // yield put({
        //     type: TOAST_SUCCESS,
        //     message: 'Challenge price successfully updated'
        // });
        if(action.onSuccess) {
            action.onSuccess(data);
        }

    } catch(e) {
        console.log('ERROR', e);
        yield put({
            type: POST_CHALLENGE_PRICE_FORM_SUCCESS
        });
        // yield put({
        //     type: TOAST_ERROR,
        //     message: e && e.message?e.message:"Oops! Something Went Wrong"
        // });
        if(action.onError) {
            action.onError(e);
        }
    }
}

export function* getLPPDetails(action) {
    try { 
        const data = yield call(postDataWithToken, LPP_GET_API_URL, action.data);
        
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        console.log('ERROR', e);
        if(action.onError) {
            action.onError(e)
        }
    }
}


export function* getCPLPPDetails(action) {
    try { 
        const data = yield call(postDataWithoutToken, CP_LPP_URL, { ... action.data });

        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        if(action.onError) {
            action.onError(e)
        }
    }
}


export function* sendExtendDate(action) {
    try{
        yield put({
            type: SAVE_EXTEND_DATE_SUBMITTING
        });
        const data = yield call(putDataWithToken, EDIT_CONTRACT_TO_DATE_URL, action.data);
        yield put({
            type: SAVE_EXTEND__DATE_SUCCESS
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message?data.message:"Oops! Something Went Wrong"
        });
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}


export function* sendLOIForApprover(action) {
    try{
        yield put({
            type: ADD_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, ADD_LOI_APPROVER_URL,  action.data);
        yield put({
            type: ADD_LOI_SUCCESS,
        });
        
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Sent LOI For Approver"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: ADD_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* sendApproverMessageForUser(action) {
    try{
        const data = yield call(putDataWithToken, SEND_APPROVER_LOI_MESSAGE_URL,  action.data);
        yield put({
            type: ACCEPT_REJECT_LOI_SUCCESS,
        });
        
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Sent Message For User"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* updateTk11Data(action) {
    try {
        const data = yield call(putDataWithToken, EDIT_TK11_CONTRACT_DATA_URL, action.data);
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Sent Message For User"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        console.log('ERROR', e);
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }

    }
}
export function* deleteTripDetails(action) {
    try{
        const data = yield call(deleteDataWithToken, DELETE_TRIP_DETAILS_URL, action.data);
       yield put({
        type: DELETE_TRIP_DETAILS_SUCCESS
        });
        
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Delete Trip Details"
        });
        
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }

}
export function* changeTripBaseVolume(action) {
    try{
        const data = yield call(putDataWithToken, CHANGE_TRIP_BASE_VOLUME_URL,  action.data);
        // yield put({
        //     type: ACCEPT_REJECT_LOI_SUCCESS,
        // });
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Updated Base Volume"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* postOtherCostCP(action) {
    try{
        yield put({
            type: CHALLENGE_PRICE_SUBMITTING
        });
        const data = yield call(putDataWithToken, POST_OTHER_COST_CP_URL,  action.data);
        yield put({
            type: CHALLENGE_PRICE_SUCCESS,
        });
        yield put({
            type: (data || {}).status === 200 ? TOAST_SUCCESS : TOAST_ERROR,
            message: (data || {}).message || "Challenge Price Submitted Successfully"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: CHALLENGE_PRICE_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* otherCostAcceptRejectCP(action) {
    try{
        yield put({
            type: ACCEPT_REJECT_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, OTHER_COST_ACCEPT_REJECT_CP_URL,  action.data);
        yield put({
            type: ACCEPT_REJECT_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Updated The Status"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        // yield put({
        //     type: COUNTER_PRICE_SUCCESS,
        // });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}


export function* getDownloadBiddingTrailDetails(action) {
    try{
        let data;
        yield put({
            type: DOWNLOAD_BIDDING_TRAIL_SUBMITTING
        });
        if(action.whoami === TRANSPORTER) {
            data = yield call(getDataWithToken, DOWNLOAD_BIDDING_PROVIDER_TRAIL_URL, action.params);
        } else {
            data = yield call(getDataWithToken, DOWNLOAD_BIDDING_SEEKER_TRAIL_URL, action.params);
        }
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        yield put({
            type: DOWNLOAD_BIDDING_TRAIL_SUCCESS,
            url: presignedUrlData?.url
        });
        if(action.onSuccess) {
            action.onSuccess(presignedUrlData);
        }
    } catch(e) {
        yield put({
            type: DOWNLOAD_BIDDING_TRAIL_SUCCESS,
            url: '/'
        });
        
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getCourierServiceCategory(action) {
	try {
		let data;
		yield put({
			type: DOWNLOAD_BIDDING_DETAILS_SUBMITTING
		});
		let url = PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE_URL;
		data = yield call(getDataWithToken, url, action.params);
		const presignedUrlData = yield call(getPresignedUrl, {
         data,
      });
		yield put({
			type: DOWNLOAD_BIDDING_DETAILS_SUCCESS,
			url: presignedUrlData.url
		});
		if (action.onSuccess) {
			action.onSuccess(presignedUrlData);
		}
	} catch (e) {
		yield put({
			type: DOWNLOAD_BIDDING_DETAILS_SUCCESS,
			url: '/'
		});

		yield put({
			type: TOAST_ERROR,
			message: e && e.message ? e.message : "Oops! Something Went Wrong"
		});
	}
}

export function* uploadCourierServiceCategory(action) {
	try {
		let data
		yield put({
			type: UPLOAD_BIDDING_DETAILS_SUBMITTING
		});
		let url = PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE_URL
		data = yield call(uploadFile, url, action.file);
		yield put({
			type: UPLOAD_BIDDING_DETAILS_SUCCESS
		});
		yield put({
			type: TOAST_SUCCESS,
			duration: 6,
			message: data && data.message ? data.message : "File Uploaded Uploaded Successfully"
		});
		if (action.onSuccess) {
			action.onSuccess(data.data);
		}
	} catch (e) {
		yield put({
			type: UPLOAD_BIDDING_DETAILS_SUCCESS
		});
		yield put({
			type: TOAST_ERROR,
			message: e && e.message ? e.message : "Oops! Something Went Wrong"
		});
	}
}


export function* clearMessage(action) {
    try{
        let data;
        // yield put({
        //     type: CLEAR_MESSAGE_SUBMITTING
        // });
            data = yield call(putDataWithToken, CLEAR_MESSAGE_URL, action.params);
        yield put({
            type: CLEAR_MESSAGE_SUCCESS,
        });
        if(action.onSuccess) {
            action.onSuccess(data.message);
        }
    } catch(e) {
        yield put({
            type: CLEAR_MESSAGE_SUCCESS,
        });
        
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getSystemSuggestedPrice(action) {
    try { 
        const data = yield call(getDataSSPWithToken, SYSTEM_SUGGESTED_PRICE_URL , action.data);
        
        if(action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch(e) {
        console.log('ERROR', e);
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* checkContractExist(action) {
    try {
        const data = yield call(getDataWithToken, CHECK_CONTRACT_EXIST_URL , action.data);
        
        if(action.onSuccess) {
            action.onSuccess(data.data || {});
        }

    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    } 
}

export function* calculateFreightRate(action) {
    try {
        const data = yield call(getDataWithToken, FREIGHT_CALCULATATION_URL, action.params);
        
        if(action.onSuccess) {
            action.onSuccess(data.data && data.data[0] || {});
        }

    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    } 
}

export function* getOtherLPPDetails(action) {
    try { 
        const data = yield call(getDataWithToken, GET_OTHERS_LPP_URL , action.data);
        
        if(action.onSuccess) {
            action.onSuccess(data.data || {})
        }
    } catch(e) {
        console.log('ERROR', e);
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* getAmmendentlist(action) {
    try{
         yield put({
             type: GET_AMMENDMENT_STARTED, 
             data: true
         });
        const data = yield call(getLCLDataWithToken, AMMENDMENT_LIST_URL, action.params);
        yield put({
            type: SAVE_AMMENDMENT_DATA_LIST,
            data: data.data || [],
            count: data.count || {}
        });
        /*if(action.onSuccess) {
            action.onSuccess();
        }*/
    } catch(e) {
        yield put({
            type: GET_AMMENDMENT_STARTED,
            data: false 
        })
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}
export function* getDownloadBiddingRate(action) {
    try{
        let data;
        yield put({
            type: DOWNLOAD_BIDDING_RATE_SUBMITTING
        });
        
            data = yield call(getDataWithToken, DOWNLOAD_BID_RATE_TEMPLATE_URL, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        yield put({
            type: DOWNLOAD_BIDDING_RATE_SUCCESS,
            url: presignedUrlData.url
        });
        if(action.onSuccess) {
            action.onSuccess(presignedUrlData);
        }
    } catch(e) {
        yield put({
            type: DOWNLOAD_BIDDING_RATE_SUCCESS,
            url: '/'
        });
        /*if(action.onError) {
            action.onError();
        }*/
    }
}

export function* putAmmendmentApproval(action) {
    try{
        //let data;
        yield put({
             type: PUT_AMMENDMENT_APPROVE_STARTED,
             data: true
         });
            const data = yield call(putLCLDataWithToken, AMMENDMENT_APPROVE_URL, action.params);
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message?data.message:"Updated Successfully"
        });
        if(action.onSuccess) {
            action.onSuccess(data.message);
        }
    } catch(e) {
        yield put({
            type: PUT_AMMENDMENT_APPROVE_STARTED
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadBiddingRate(action) {
    try{
        let data
        yield put({
            type: UPLOAD_BIDDING_RATE_SUBMITTING
        });
        
            data = yield call(uploadFileWithSyncCalls, UPLOAD_BID_RATE_URL, action.file, action.params);
        
        yield put({
            type: UPLOAD_BIDDING_RATE_SUCCESS
        });
        
        yield put({
            type: (data.status === 400) ? TOAST_ERROR : TOAST_SUCCESS,
            duration: 6,
            message: data && data.message ? data.message : "Bidding Details Uploaded Successfully"
        });
        if(action.onSuccess) {
            console.log('ON SUCCESS BIDDING DETASILS');
            action.onSuccess(data.data);
        }
    } catch(e) {
        yield put({
            type: UPLOAD_BIDDING_RATE_SUCCESS
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getDownloadTrucksDetails(action) {
    try{
        let data;
        yield put({
            type: DOWNLOAD_TRUCKS_SUBMITTING
        });
        
        data = yield call(getDataWithToken, DOWNLOAD_TRUCKS_DETAILS_TEMPLATE_URL, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        yield put({
            type: DOWNLOAD_TRUCKS_SUCCESS,
            url: presignedUrlData.url
        });
        if(action.onSuccess) {
            action.onSuccess(presignedUrlData);
        }
    } catch(e) {
        yield put({
            type: DOWNLOAD_TRUCKS_SUCCESS,
            url: '/'
        });
        /*if(action.onError) {
            action.onError();
        }*/
    }
}


export function* uploadTrucksDetails(action) {
    try{
        let data
        yield put({
            type: UPLOAD_NUMBER_OF_TRUCKS_SUBMITTING
        });
        
            data = yield call(uploadFileWithSyncCalls, UPLOAD_TRUCKS_DETAILS_URL, action.file, action.params);
        
        yield put({
            type: UPLOAD_NUMBER_OF_TRUCKS_SUCCESS
        });
        
        yield put({
            type: (data.status === 400) ? TOAST_ERROR : TOAST_SUCCESS,
            duration: 6,
            message: data && data.message ? data.message : "Trucks Details Uploaded Successfully"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch(e) {
        yield put({
            type: UPLOAD_NUMBER_OF_TRUCKS_SUCCESS
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* saveNumberOfVehiclePlaced(action) {
    try{
        yield put({
            type: NUMBER_OF_VEHICLE_PLACED_SUBMITTING
        });
        const data = yield call(putDataWithToken, NUMBER_OF_VEHICLE_PLACED_URL,  action.data);
        yield put({
            type: NUMBER_OF_VEHICLE_PLACED_SUCCESS,
        });
        yield put({
            type: (data.status === 400) ? TOAST_ERROR : TOAST_SUCCESS,
            duration: 6,
            message: data && data.message ? data.message : "Placed number of vehicle successfully!!"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: NUMBER_OF_VEHICLE_PLACED_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* getExistingContracts(action) {
    try{
        yield put({
            type: START_LOADER
        });
        yield put({
            type: GET_EXISTING_CONTRACT_DETAILS_SUBMITTING
        })
        const data = yield call(getDataWithToken, EXISITING_CONTRACT_DETAILS_URL,  action.params);
        yield put({
            type: GET_EXISTING_CONTRACT_DETAILS_SUCCESS,
            data: data.data || []
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: GET_EXISTING_CONTRACT_DETAILS_SUCCESS,
            data: []
        });
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postGenerateContractDetails(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(postDataWithToken, GENERATE_CONTRACT_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Contract Generated Successfully"
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* downloadMultiModeContracts(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, DOWNLOAD_MULTIMODE_EXISITING_CONTRACT_URL, action.data);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(action.onSuccess && presignedUrlData) {
            action.onSuccess(presignedUrlData);
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadMultiModeContracts(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, UPLOAD_MULTIMODE_EXISITING_CONTRACT_URL, action.file);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}


export function* revokeWithdrawBid(action) {
    try{
        
        yield put({
            type: REVOKE_WITHDRAW_BID_SUBMITTING
        });
        const data = yield call(putDataWithToken, REVOKE_WITHDRAW_BID_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }

        yield put({
            type: (data.status === 400) ? TOAST_ERROR : TOAST_SUCCESS,
            message: "Successfully Revoke Bid withdrawn",
            duration: 8
        });
        yield put({
            type: REVOKE_WITHDRAW_BID_SUCCESS
         });
        
    } catch(e) {
        yield put({
            type: REVOKE_WITHDRAW_BID_SUCCESS
         });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getGeneratedContracts(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GENERATED_CONTRACTS_LIST_URL);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: GET_GENERATED_CONTRACT_DETAILS_SUCCESS,
            data: data.data || []
        })
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: GET_GENERATED_CONTRACT_DETAILS_SUCCESS,
            data: []
        });
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* rfqClosed(action) {
    try{
        const data = yield call(putDataWithToken, CLOSED_RFQ_URL,  action.data);
        yield put({
            type: ACCEPT_REJECT_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully RFQ Closed"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* acceptanceCeilingPrice(action) {
    try{
        const data = yield call(putDataWithToken, ACCEPTANCE_OF_CEILING_PRICE_URL,  action.data);
        yield put({
            type: ACCEPT_REJECT_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: "Sent Sucessfully"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* cancelledLoi(action) {
    try{
        yield put({
            type: LOI_CANCELLED_SUBMITTING,
        });
        const data = yield call(putDataWithToken, CANCELLED_LOI_URL,  action.data);
       
        yield put({
            type: TOAST_SUCCESS,
            message: "LOI Cancelled Sucessfully"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }

        yield put({
            type: LOI_CANCELLED_UPDATED_SUCCESS
         });
    } catch(e) {

        yield put({
            type: LOI_CANCELLED_UPDATED_SUCCESS
         });

        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* downloadAwlMultiModeTemplate(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, DOWNLOAD_AWL_MULTIMODE_TEMPLATE_URL, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(action.onSuccess && presignedUrlData) {
            action.onSuccess(presignedUrlData);
        }
        yield put({
            type: data.status === 200 ? TOAST_SUCCESS : TOAST_ERROR,
            message: data.message
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadAwlMultiModeTrips(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, UPLOAD_AWL_MULTIMODE_EXCEL_URL, action.file, action.params);
        if(action.onSuccess) {
            action.onSuccess(data.data || {});
        }
        yield put({
            type: data.status === 200 ? TOAST_SUCCESS : TOAST_ERROR,
            message: data.message || 'Uploaded Successfully'
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getCargoShipmentTrackingData(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(postDataWithToken, action.cargoType === 2 ? AIR_SHIPMENT_TRACKING_URL : (action.trackingType === 1 ? CONTAINER_SHIPMENT_TRACKING_URL : BL_SHIPMENT_TRACKING_URL), action.data);
        yield put({
           type: SAVE_CARGO_SHIPMENT_TRACKING_DATA,
           data: data.data || []
        })
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: SAVE_CARGO_SHIPMENT_TRACKING_DATA,
            data: []
        })
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getRouteMaster(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(getAdminDataWithToken, GET_ROUTE_MASTER_URL, action.params);
        if(action.onSuccess) {
            action.onSuccess(data.data || [])
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* addRouteMaster(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(postDataWithToken, ADD_ROUTE_MASTER_URL, action.data, '', adminBaseUrl);
        if(action.onSuccess) {
            action.onSuccess()
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* updateRouteMaster(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, UPDATE_ROUTE_MASTER_URL, action.data, adminBaseUrl);
        if(action.onSuccess) {
            action.onSuccess()
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* deleteRouteMaster(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(deleteDataWithToken, DELETE_ROUTE_MASTER_URL, {}, action.data, adminBaseUrl);
        if(action.onSuccess) {
            action.onSuccess()
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadRouteMaster(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, UPLOAD_ROUTE_MASTER_DETAILS_URL, action.file, action.params, adminBaseUrl);
        if(action.onSuccess) {
            action.onSuccess()
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* downloadRouteMasterDetails(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getAdminDataWithToken, DOWNLOAD_ROUTE_MASTER_DETAILS_URL, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(data && presignedUrlData?.url){
            downloadUrl(presignedUrlData?.url);
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* downloadRouteMasterTemplate(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getAdminDataWithToken, DOWNLOAD_ROUTE_MASTER_TEMPLATE_URL, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(data && (presignedUrlData.url)){
            downloadUrl(presignedUrlData.url);
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* checkFtlContractExist(action) {
    try{
        const data = yield call(postDataWithToken, CHECK_FTL_CONTRACT_EXIST_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess(data.data || {});
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postSOBDetails(action) {
    try{
        // yield put({
        //     type: SEND_LOI_SUBMITTING
        // });
        const data = yield call(putDataWithToken, SHARE_OF_BUSINESS_URL,  action.data);
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        // yield put({
        //     type: TOAST_SUCCESS,
        //     message: "Data Updated Successfully"
        // });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* updateDPHDetails(action) {
    try{
        yield put({
            type: SEND_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, UPDATE_DPH_URL,  action.data);
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        if(action.onSuccess) {
            action.onSuccess()
        }
    } catch(e) {
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* postTripLevelContractExtension(action) {
    try {
        yield put({
            type: SEND_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, EXTEND_TRIP_LEVEL_CONTRACT_TENURE_URL,  action.data);
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        if(action.onSuccess) {
            action.onSuccess()
        }
    } catch(e) {
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });

    }
}

export function* postTripLevelBidExtension(action) {
    try {
        yield put({
            type: SEND_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, TRIP_LEVEL_BID_TIME_EXTENSION_URL,  action.data);
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        if(action.onSuccess) {
            action.onSuccess()
        }
    } catch(e) {
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });

    }
}

export function* approverRejectsLoi(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, REJECT_LOI_FROM_APPROVER_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: (data || {}).message || "Successfully Rejected the LOI"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* downloadExistingContractTemplate(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const seekerCompanyId = getItemFromLocal('transporter_seeker_company_id');
        const url = (isEmami(seekerCompanyId) && (action.params || {}).rfqType == 6) ? DOWNLOAD_MULTIMODAL_OFFLINE_CONTRACT_URL: DOWNLOAD_EXIST_CONTRACT_TEMPLATE_URL;
        const data = yield call(getDataWithToken, url, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(data && presignedUrlData?.url) {
            downloadUrl(presignedUrlData?.url);
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadExistingContract(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const seekerCompanyId = getItemFromLocal('transporter_seeker_company_id');
        const url = (isEmami(seekerCompanyId) && (action.params || {}).rfqType == 6) ? UPLOAD__MULTIMODAL_OFFLINE_CONTRACT_URL : UPLOAD_EXIST_CONTRACT_URL
        const data = yield call(uploadFile, url, action.file, action.params);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Data Uploaded Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadRFQFile(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, UPLOAD_FILE_IN_CONTRACT_RECORDS_RFQ_URL, action.file, action.params);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Data Uploaded Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postCreateIndents(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(postDataWithToken, CREATE_INDENTS_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Indent Created Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* deleteUploadedFile(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, DELETE_UPLOADED_FILE_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "File Deleted Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postDPHApproval(action) {
    try{
        yield put({
            type: ADD_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, POST_DPH_APPROVER_URL,  action.data);
        yield put({
            type: ADD_LOI_SUCCESS,
        });
        
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Sent DPH For Approver"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        yield put({
            type: ADD_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* postApproveDPH(action) {
    try{
        yield put({
            type: ADD_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, POST_DPH_APPROVAL_URL,  action.data);
        yield put({
            type: ADD_LOI_SUCCESS,
        });
        
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Approved the DPH"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch(e) {
        yield put({
            type: ADD_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* retriggerTK11ForRFQ(action) {
    try {
        yield put({
            type: ADD_LOI_SUBMITTING
        });
        const data = yield call(postDataWithToken, RETRIGGER_TK11_FOR_RFQ_URL,  action.data);
        yield put({
            type: ADD_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Updated"
        });
        if(action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch(e) {
        yield put({
            type: ADD_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* getEventManagementDetails(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_EVENT_DETAILS_URL, action.params);
        yield put({
            type: SAVE_EVENT_DETAILS,
            data: data.data || {}
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* deleteEventDetails(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(deleteDataWithToken, DELETE_EVENT_DETAIL_URL, action.data);
       if(action.onSuccess) {
            action.onSuccess();
       }
        yield put({
            type: END_LOADER
        });

    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* downloadEventDetailTemplate(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, DOWNLOAD_EVENT_DETAIL_TEMPLATE_URL, action.data);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
       if(action.onSuccess) {
            action.onSuccess(presignedUrlData || {});
       }
        yield put({
            type: END_LOADER
        });

    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadRFQsforEvent(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, UPLOAD_RFQS_FOR_EVENT_URL, action.file, action.params);
       if(action.onSuccess) {
            action.onSuccess();
       }
        yield put({
            type: END_LOADER
        });

    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* scheduleEvent(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, SCHEDULE_EVENT_URL, action.params);
        yield put({
            type: END_LOADER
        });
        if(action.onSuccess) {
            action.onSuccess();
        } else {
            location.href = '/eventManagement';
        }
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getEventStatus(action) {
    try {
        const data = yield call(getDataWithToken, GET_EVENT_STATUS_URL, action.params);
        yield put({
            type: SAVE_EVENT_STATUS,
            data: (data.data && (data.data || {}).event_rfq_list || [])
        });
        if(action.onSuccess) {
            action.onSuccess()
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getEventRFQTrips(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_EVENT_RFQ_DETAILS_URL, action.params);
        if(action.onSuccess && data.data) {
            action.onSuccess(data.data);
        }
        // yield put({
        //     type: GET_RFQ_DETAIL_SUCCESS,
        //     rfq: transformRfq((data.data && (data.data || {}).rfq || {}))
        // })
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* updateEventRFQ(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, UPDATE_EVENT_RFQ_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Updated Deleted Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* updateEventRFQTrips(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, UPDATE_EVENT_RFQ_TRIPS_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Updated Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadSOBDetails(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, POST_SOB_TEMPLATE_URL, action.file, action.params);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || 'Data Uploaded Successfully'
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* downloadSOBTemplate(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_SOB_TEMPLATE_URL, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(action.onSuccess) {
            action.onSuccess(presignedUrlData && presignedUrlData.url || '');
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getWinningTransporters(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_WINNING_TRANSPORTERS_URL, action.params);
        yield put({
            type: SAVE_WINNING_TRANSPORTERS,
            data: (data.data || {})
        });
        if(action.onSuccess) {
            action.onSuccess()
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* deleteTransporterInWinningPage(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(deleteDataWithToken, DELETE_WINNING_TRANSPORTER_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess()
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Transporter Deleted Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadOfflineSlabWiseTrips(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, POST_UPLOAD_OFFLINE_SLABWISE_TRIPS_URL, action.file, action.params);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || 'Data Uploaded Successfully'
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* downloadOfflineSlabWiseTrips(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_OFFLINE_SLABWISE_TRIPS_TEMPLATE_URL, action.params);
        if(action.onSuccess) {
            action.onSuccess(data.data && data.data.link || '');
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getMasterContracts(action) {
    try {
        yield put({
            type: GET_ALL_MASTER_CONTRACTS_LOADING
        });
        const data = yield call(getDataWithToken, GET_ALL_MASTER_CONTRACTS_URL, action.params);
        yield put({
            type: GET_ALL_MASTER_CONTRACTS_SUCCESS,
            masterContracts: data.data && data.data.list,
            count: data.data && data.data.count
        });
        if (action.onSuccess) {
            action.onSuccess(data.data.list);
        }
    } catch (e) {
        yield put({
            type: GET_ALL_MASTER_CONTRACTS_SUCCESS,
            masterContracts: [],
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}
export function* getFromRoutes(action) {
    try {
        yield put({
            type: GET_FROM_ROUTE_LOADING
        });
        const data = yield call(getDataWithToken, GET_FROM_ROUTE_LIST_URL, action.params);
        yield put({
            type: GET_FROM_ROUTE_SUCCESS,
            fromRoutes: data.data
        });
        if (action.onSuccess) {
            action.onSuccess(data.data);
            console.log(data.data, 'data.data=--==--=');
        }
    } catch (e) {
        yield put({
            type: GET_FROM_ROUTE_SUCCESS,
            fromRoutes: [],
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}
export function* getBranchYardFilters(action) {
    try {
        yield put({
            type: GET_BRANCH_YARD_FILTERS_LOADING
        });
        const data = yield call(getDataWithToken, GET_BRANCH_YARD_URL, action.params);
        yield put({
            type: GET_BRANCH_YARD_FILTERS_SUCCESS,
            branchYardFilters: data.data
        });
        if (action.onSuccess) {
            action.onSuccess(data.data);
            console.log(data.data, 'data.data=--==--=');
        }
    } catch (e) {
        yield put({
            type: GET_BRANCH_YARD_FILTERS_SUCCESS,
            branchYardFilters: [],
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}
export function* postSearchRoutes (action) {
    try {
        yield put({
            type: POST_SEARCH_ROUTES_CONTRACTS_LOADING
        });
        const data = yield call(postDataWithToken, POST_SEARCH_ROUTE_MASTER_URL, action.data,action.params);
        yield put({
            type: POST_SEARCH_ROUTES_CONTRACTS_SUCCESS,
            searchRoutesContract: data.data
        });
        if (action.onSuccess) {
            action.onSuccess(data.data);
            console.log(data.data, 'data.data=--==--=');
        }
    } catch (e) {
        yield put({
            type: POST_SEARCH_ROUTES_CONTRACTS_SUCCESS,
            searchRoutesContract: [],
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}

export function* generatePlanInMasterContract(action) {
    try {
        const data = yield call(postDataWithToken, GENERATE_PLAN_IN_MASTER_CONTRACT_URL, action.data ,action.params);
        if (action.onSuccess) {
            action.onSuccess(data.data);
        }
        yield put({
            type: TOAST_SUCCESS,
            message: 'Contract Generated Successfully!'
        });
    } catch (e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}

export function* getGenerateRouteCodes(action) {
    try {
        const data = yield call(getDataWithToken, GET_GENERATE_ROUTE_CODES_URL, action.params);
        if (action.onSuccess) {
            action.onSuccess(data.data);
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Updated Successfully"
        });
    } catch (e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}

export function* addAdditionalTransporter(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, ADD_ADDITIONAL_TRANSPORTERS_DURING_BIDDING_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Updated Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getRfqlevelPRDetails(action) {
    try {
        const data = yield call(getDataWithToken, GET_RFQ_LEVEL_REVISED_PRICE_DETAILS_URL, action.data);
        if (action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch (e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
    }
}

export function* getTransporterlevelPRDetails(action) {
    try {
        const data = yield call(getDataWithToken, action.isTransporter ? GET_TRANSPORTER_WISE_REVISED_PRICE_URL : GET_TRANSPORTER_REVISED_PRICE_DETAILS_URL, action.data);
        if (action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch (e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
    }
}

export function* downloadPRDetails(action) {
    try {
        const data = yield call(getDataWithToken, DOWNLOAD_REVISED_PRICE_DETAILS_URL, action.data);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if (action.onSuccess) {
            action.onSuccess(presignedUrlData || {});
        }
    } catch (e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
    }
}

export function* getContractDetails(action) {
    try {
        yield put({
            type: GET_CONTRACT_DETAILS_LOADING
        });
        const data = yield call(getDataWithToken, GET_CONTRACT_DETAILS_URL, action.params);
        yield put({
            type: GET_CONTRACT_DETAILS_SUCCESS,
            data: data.data && data.data.length && data.data[0] || {}
        });
        if (action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch (e) {
        yield put({
            type: GET_CONTRACT_DETAILS_SUCCESS,
            data: {}
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}

export function* getChildContractTk11(action) {
    try {
        yield put({
            type: GET_CONTRACT_CHILD_DETAILS_LOADING
        });
        const data = yield call(getDataWithToken, GET_CHILD_CONTRACT_TK11_URL, action.params);
        yield put({
            type: GET_CONTRACT_CHILD_DETAILS_SUCCESS,
            data: data.data || []
        });
        if (action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch (e) {
        yield put({
            type: GET_CONTRACT_CHILD_DETAILS_SUCCESS,
            data: []
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}

export function* getMasterContractTk11(action) {
    try {
        yield put({
            type: GET_CONTRACT_CHILD_DETAILS_LOADING
        });
        const data = yield call(getDataWithToken, GET_MASTER_CONTRACT_TK11_URL, action.params);
        yield put({
            type: GET_CONTRACT_CHILD_DETAILS_SUCCESS,
            data: data.data || []
        });
        if (action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch (e) {
        yield put({
            type: GET_CONTRACT_CHILD_DETAILS_SUCCESS,
            data: []
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}

export function* uploadOtherCharges(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, UPLOAD_OTHER_CHARGES_URL, action.file, action.params);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || 'Data Uploaded Successfully'
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getOtherChargesTemplate(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_OTHER_CHARGES_TEMPLATE_URL, action.params);
         const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(action.onSuccess) {
            action.onSuccess(presignedUrlData && presignedUrlData.url || '');
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* updatePostBidToPreBidRFQ(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, UPDATE_POST_BID_TO_PRE_BID_RFQ_URL, action.data);
        if (action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message:data && data.message || 'Updated Successfully'
        });
        yield put({
            type: END_LOADER
        });
        
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* downloadTransporterWiseBidDetails(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, DOWNLOAD_TRANSPORTER_WISE_BID_DETAILS_URL, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(data && presignedUrlData && presignedUrlData.url) {
            downloadUrl(presignedUrlData.url);
        }
        yield put({
            type: END_LOADER
        });
        
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* retriggerMasterContract(action) {
    try {
        yield put({
            type: RETRIGGER_MASTER_CONTRACTS_TK11_LOADING
        });
        const data = yield call(postDataWithToken, RETRIGGER_MASTER_CONTRACT_TK11_URL, action.data);
        if (action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: RETRIGGER_MASTER_CONTRACTS_TK11_SUCCESS
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Retriggered Successfully"
        });
    } catch (e) {
        yield put({
            type: RETRIGGER_MASTER_CONTRACTS_TK11_SUCCESS
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
    }
}

export function* saveRetriggerMasterContract(action) {
    try {
        yield put({
            type: RETRIGGER_MASTER_CONTRACTS_TK11_LOADING
        });
        const data = yield call(putDataWithToken, SAVE_RETRIGGER_MC_TK11_URL, action.data);
        if (action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: RETRIGGER_MASTER_CONTRACTS_TK11_SUCCESS
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Saved Successfully"
        });
    } catch (e) {
        yield put({
            type: RETRIGGER_MASTER_CONTRACTS_TK11_SUCCESS
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
    }
}

export function* getLocationDropdownValues(action) {
    try {
        const data = yield call(getDataWithToken, GET_LOCATION_DROPDOWN_VALUES_URL, action.params);
        if (action.onSuccess) {
            action.onSuccess(data && data.data && data.data.list || []);
        }
    } catch (e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}

export function* getSecondaryContractlist(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_SECONDARY_CONTRACTS_URL, action.params);
        yield put({
            type: SAVE_SECONDARY_CONTRACTS_LIST,
            data: (data.data || {}).list || []
        })
        yield put({
            type: END_LOADER
        });
        
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* downloadTripsSecondaryContractsTripsTemplate(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, DOWNLOAD_SECONDARY_CONTRACTS_TEMPLATE_URL, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(data && presignedUrlData && presignedUrlData.url) {
            downloadUrl(presignedUrlData.url);
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        })
    }
}

export function* uploadSecondaryContractsTrips(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, UPLOAD_SECONDARY_CONTRACTS_TRIPS_URL, action.file, action.params);
        if(action.onSuccess) {
            action.onSuccess(data && data.data || {});
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        })
    }
}

export function* saveSecondaryContracts(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(postDataWithToken, POST_SECONDARY_CONTRACTS_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        })
    }
}

export function* deleteSecondaryContractRFQ(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(deleteDataWithToken, DELETE_SECONDARY_CONTRACT_RFQ_URL, action.data);
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || 'Deleted Successfully'
        })
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        })
    }
}

export function* getContractByRFQId(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_SECONDARY_CONTRACT_BY_RFQID_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess(data && data.data || {});
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        })
    }
}

export function* updateSecondaryContrats(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, UPDATE_SECONDARY_CONTRACTS_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        })
    }
}

export function* multiContractSendLoiForApproval(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, MULTI_CONTRACT_SEND_LOI_FOR_APPROVAL_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        })
    }
}

export function* approveMultiContract(action) {
    try {
        yield put({
            type: POST_MULTICONTRACT_APPROVE_LOADING
        });
        const data = yield call(postDataWithToken, POST_MULTICONTRACT_APPROVE_URL, action.data);
        if (action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: POST_MULTICONTRACT_APPROVE_SUCCESS
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Retriggered Successfully"
        });
    } catch (e) {
        yield put({
            type: POST_MULTICONTRACT_APPROVE_SUCCESS
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
    }
}

export function* rejectMultiContract(action) {
    try {
        yield put({
            type: POST_MULTICONTRACT_APPROVE_LOADING
        });
        const data = yield call(postDataWithToken, POST_MULTICONTRACT_REJECT_URL, action.data);
        if (action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: POST_MULTICONTRACT_APPROVE_SUCCESS
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Retriggered Successfully"
        });
    } catch (e) {
        yield put({
            type: POST_MULTICONTRACT_APPROVE_SUCCESS
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
    }
}

export function* downloadMultiContractTemplate(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, DOWNLOAD_TEMPLATE_MULTI_CONTRACT_URL, action.params);
        const presignedUrlData = yield call(getPresignedUrl, {
            data,
        });
        if(data && presignedUrlData && presignedUrlData.url) {
            downloadUrl(presignedUrlData.url);
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* uploadMultiContract(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, UPLOAD_MULTI_CONTRACT_URL, action.file, action.params);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Data Uploaded Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getMultiContracts(action) {
    try {
        yield put({
            type: GET_MULTI_CONTRACT_LOADING
        });
        const data = yield call(getDataWithToken, GET_MULTI_CONTRACT_DATA_URL, action.params);
        yield put({
            type: GET_MULTI_CONTRACT_SUCCESS,
            data: data.data
        });
        if (action.onSuccess) {
            action.onSuccess(data.data);
        }
    } catch (e) {
        yield put({
            type: GET_MULTI_CONTRACT_SUCCESS,
            data: [],
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : "Oops! Something Went Wrong"
        });
        if (action.onError) {
            action.onError(e)
        }
    }
}

export function* deleteMultiContract(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(deleteDataWithToken, DELETE_MULTI_CONTRACT_URL, action.data);
        if (action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: "Successfully Delete Trip Details"
        });
        yield put({
            type: END_LOADER
        });
        
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
        if(action.onError) {
            action.onError(e)
        }
    }

}

export function* updateMultiContract(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, UPDATE_MULTI_CONTRACT_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Updated Deleted Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* downloadOfflineContractsDetails(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_OFFLINE_CONTRACTS_DETAILS_TO_UPDATE_URL, action.params);
        if(data && data.data && (data.data || {}).link) {
            downloadUrl((data.data || {}).link);
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postOfflineContractsUpdatedDetails(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(uploadFile, POST_OFFLINE_CONTRACTS_DETAILS_UPDATED_DETAILS_URL, action.file, action.params);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || 'Data Uploaded Successfully'
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postTripFileRemarks(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, POST_TRIP_FILE_REMARKS_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Data updated successfully!"
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postOverallAllocation(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, POST_OVERALL_ALLOCATION_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Data updated successfully!"
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postCostHeadCPAcceptReject(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, POST_COST_HEAD_CP_ACCEPT_REJECT_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Data updated successfully!"
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postCostHeadCounterPrice(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, POST_COST_HEAD_COUNTER_PRICE_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Data updated successfully!"
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* postCostHeadCounterAcceptReject(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, POST_COST_HEAD_COUNTER_ACCEPT_REJECT_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Data updated successfully!"
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* deleteSecondaryContractRFQTrips(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(deleteDataWithToken, DELETE_SECONDARY_CONTRACT_RFQ_TRIP_URL, action.data);
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || 'Deleted Successfully'
        })
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        })
    }
}

export function* updateSingleBiddedTripsTime(action) {
    try {
        yield put({
            type: SEND_LOI_SUBMITTING
        });
        const data = yield call(putDataWithToken, EXTEND_BID_TIME_FOR_SINGLE_BIDDED_TRIPS_URL,  action.data);
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        if(action.onSuccess) {
            action.onSuccess()
        }
    } catch(e) {
        yield put({
            type: SEND_LOI_SUCCESS,
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });

    }
}

export function* postSecondaryContractValidation(action) {
    try {
        const data = yield call(postDataWithToken, SECONDARY_CONTRACT_TENURE_VALIDATION_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess(data.data || {});
        }
    } catch(e) {
        if(action.onError) {
            action.onError(e.data || {});
        }
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });

    }
}

export function* reactivateTk11(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(putDataWithToken, REACTIVATE_TK11_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || 'Reactivated Successfully'
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });

    }
}

export function* cancelCP(action) {
    try {
        yield put({
            type: START_LOADER
        });
        const data = yield call(postDataWithToken, CANCEL_CP_URL,  action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || 'CP Cancelled Successfully'
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });

    }
}

export function* acceptTermsAndConditions(action) {
    try {
        const data = yield call(postDataWithToken, ACCEPT_TERMS_AND_CONDITIONS_URL, action.data);
        if (action.onSuccess) {
            action.onSuccess(data);
        }
        yield put({
            type: TOAST_SUCCESS,
            message: (data && data.message) || 'Terms and Conditions accepted successfully'
        });
    } catch (e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message ? e.message : 'Oops! Something Went Wrong'
        });
    }
}

export function* getProcurementLPPDetails(action) {
    try {
        const data = yield call(postDataWithToken, GET_PROCUREMENT_LPP_URL, action.data);
        
        if(action.onSuccess) {
            action.onSuccess(data.data)
        }
    } catch(e) {
        console.log('ERROR', e);
        if(action.onError) {
            action.onError(e)
        }
    }
}

export function* getPRTrackingDetails(action) {
    try { 
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_PR_TRACKING_URL, action.params);
        yield put({
            type: SAVE_PR_TRACKING_DETAILS,
            data: data.data || []
        })
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getTripsErrorLogs(action) {
    try { 
        yield put({
            type: START_LOADER
        });
        const data = yield call(getDataWithToken, GET_TRIPS_LOGS_URL, action.params);
       if(action.onSuccess) {
            action.onSuccess(data.data || []);
       }
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* deleteContractRecord(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(deleteDataWithToken, DELETE_CONTRACT_RECORD_URL, {}, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Contract Deleted Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }

}

export function* generateServicePO(action) {
    try{
        yield put({
            type: START_LOADER
        });
        const data = yield call(postDataWithToken, GENERATE_SERVICE_PO_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess(data);
        }
        yield put({
            type: TOAST_SUCCESS,
            message: data && data.message || "Service PO Generated Successfully"
        });
        yield put({
            type: END_LOADER
        });
    } catch(e) {
        yield put({
            type: END_LOADER
        });
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}

export function* getSidebarConfigDetails(action) {
    try{
        const data = yield call(getAdminDataWithToken, GET_SIDEBAR_CONFIG_URL, action.params);
        
        if (action.onSuccess) {
            action.onSuccess(data?.data?.list?.user_contracting_dashboards ||[]);
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Please configure the dashboard access for user in admin"
        });
    }
}

export function* getDaaiConfigDetails(action) {
    try{
        const data = yield call(getAdminDataWithToken, GET_DAAI_INTEGRATION_CONFIG_URL, action.params);

        if (action.onSuccess) {
            action.onSuccess(data?.data?.list ||[]);
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Please configure the reports & dashboards"
        });
    }
}

export function* getCompanyData(action) {
    try{
        const data = yield call(getIndentingDataWithToken, FETCH_COMPANY_DATA_URL, action.params, action.isSeeker);

        if (action.onSuccess) {
            action.onSuccess(data?.data?.list || []);
        }
    } catch(e) {
        yield put({
            type: TOAST_ERROR,
            message: e && e.message?e.message:"Oops! Something Went Wrong"
        });
    }
}
